import React, { useMemo } from "react";

// Cinematic atmospheric background: drifting mist, embers, distant lanterns
export const Atmosphere = ({ variant = "full" }) => {
  const embers = useMemo(
    () =>
      Array.from({ length: 24 }).map((_, i) => ({
        left: Math.random() * 100,
        delay: Math.random() * 12,
        duration: 10 + Math.random() * 14,
        size: 1 + Math.random() * 3,
      })),
    []
  );

  const mistClouds = useMemo(
    () =>
      Array.from({ length: 5 }).map((_, i) => ({
        top: 10 + i * 18 + Math.random() * 6,
        delay: i * 4,
        duration: 24 + Math.random() * 16,
      })),
    []
  );

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" data-testid="atmosphere-layer">
      {/* Mist clouds */}
      {mistClouds.map((m, i) => (
        <div
          key={`m-${i}`}
          className="mist-cloud"
          style={{
            top: `${m.top}%`,
            animationDelay: `${m.delay}s`,
            animationDuration: `${m.duration}s`,
          }}
        />
      ))}

      {/* Floating embers */}
      {embers.map((e, i) => (
        <span
          key={`e-${i}`}
          className="ember"
          style={{
            left: `${e.left}%`,
            animationDelay: `${e.delay}s`,
            animationDuration: `${e.duration}s`,
            width: `${e.size}px`,
            height: `${e.size}px`,
          }}
        />
      ))}

      {/* Distant lanterns (only in full variant) */}
      {variant === "full" && (
        <>
          <div className="lantern" style={{ top: "12%", left: "8%", animationDelay: "0s" }} />
          <div className="lantern" style={{ top: "18%", right: "10%", animationDelay: "1.5s", transform: "scale(0.8)" }} />
          <div className="lantern" style={{ top: "55%", left: "4%", animationDelay: "2.5s", transform: "scale(0.6)" }} />
          <div className="lantern" style={{ top: "62%", right: "6%", animationDelay: "0.8s", transform: "scale(0.7)" }} />
        </>
      )}
    </div>
  );
};
